import 'babel-polyfill';

import React from 'react';
import { render } from 'react-dom';
import { initSentry } from '~frontend-common/helper/core/sentry';
import { App } from './app';
import { FrontendWebPortalConfig } from './config';

initSentry(FrontendWebPortalConfig.sentry.dsn, FrontendWebPortalConfig.sentry.environment);

render(<App />, document.querySelector('#root'));
